<template>
  <div class="side">
    <div class="view">{{ view }}</div>
    <v-touch
      @swipeleft="
        direction1
          ? horizontalSweep('upLeft', 'up', 'anticlockwise')
          : horizontalSweep('upRight', 'up', 'clockwise')
      "
      @swiperight="
        direction1
          ? horizontalSweep('upRight', 'up', 'clockwise')
          : horizontalSweep('upLeft', 'up', 'anticlockwise')
      "
      :swipe-options="{ threshold: 10 }"
      class="row"
    >
      <v-touch
        @swipeup="
          direction
            ? verticalSweep('leftUp', 'left', 'clockwise')
            : verticalSweep('leftDown', 'left', 'anticlockwise')
        "
        @swipedown="
          direction
            ? verticalSweep('leftDown', 'left', 'anticlockwise')
            : verticalSweep('leftUp', 'left', 'clockwise')
        "
        class="sub-box"
        :class="{
          red: grid.row1.box1.isRed,
          blue: grid.row1.box1.isBlue,
          yellow: grid.row1.box1.isYellow,
          green: grid.row1.box1.isGreen,
          gray: grid.row1.box1.isGray,
          pink: grid.row1.box1.isPink,
        }"
      ></v-touch>
      <v-touch
        @swipeup="direction ? verticalSweep('midUp') : verticalSweep('midDown')"
        @swipedown="
          direction ? verticalSweep('midDown') : verticalSweep('midUp')
        "
        class="sub-box"
        :class="{
          red: grid.row1.box2.isRed,
          blue: grid.row1.box2.isBlue,
          yellow: grid.row1.box2.isYellow,
          green: grid.row1.box2.isGreen,
          gray: grid.row1.box2.isGray,
          pink: grid.row1.box2.isPink,
        }"
      ></v-touch>
      <v-touch
        @swipeup="
          direction
            ? verticalSweep('rightUp', 'right', 'anticlockwise')
            : verticalSweep('rightDown', 'right', 'clockwise')
        "
        @swipedown="
          direction
            ? verticalSweep('rightDown', 'right', 'clockwise')
            : verticalSweep('rightUp', 'right', 'anticlockwise')
        "
        class="sub-box"
        :class="{
          red: grid.row1.box3.isRed,
          blue: grid.row1.box3.isBlue,
          yellow: grid.row1.box3.isYellow,
          green: grid.row1.box3.isGreen,
          gray: grid.row1.box3.isGray,
          pink: grid.row1.box3.isPink,
        }"
      ></v-touch>
    </v-touch>
    <v-touch
      @swipeleft="
        direction1 ? horizontalSweep('midLeft') : horizontalSweep('midRight')
      "
      @swiperight="
        direction1 ? horizontalSweep('midRight') : horizontalSweep('midLeft')
      "
      class="row"
    >
      <v-touch
        @swipeup="
          direction
            ? verticalSweep('leftUp', 'left', 'clockwise')
            : verticalSweep('leftDown', 'left', 'anticlockwise')
        "
        @swipedown="
          direction
            ? verticalSweep('leftDown', 'left', 'anticlockwise')
            : verticalSweep('leftUp', 'left', 'clockwise')
        "
        class="sub-box"
        :class="{
          red: grid.row2.box1.isRed,
          blue: grid.row2.box1.isBlue,
          yellow: grid.row2.box1.isYellow,
          green: grid.row2.box1.isGreen,
          gray: grid.row2.box1.isGray,
          pink: grid.row2.box1.isPink,
        }"
      ></v-touch>
      <v-touch
        @swipeup="direction ? verticalSweep('midUp') : verticalSweep('midDown')"
        @swipedown="
          direction ? verticalSweep('midDown') : verticalSweep('midUp')
        "
        class="sub-box"
        :class="{
          red: grid.row2.box2.isRed,
          blue: grid.row2.box2.isBlue,
          yellow: grid.row2.box2.isYellow,
          green: grid.row2.box2.isGreen,
          gray: grid.row2.box2.isGray,
          pink: grid.row2.box2.isPink,
        }"
      ></v-touch>
      <v-touch
        @swipeup="
          direction
            ? verticalSweep('rightUp', 'right', 'anticlockwise')
            : verticalSweep('rightDown', 'right', 'clockwise')
        "
        @swipedown="
          direction
            ? verticalSweep('rightDown', 'right', 'clockwise')
            : verticalSweep('rightUp', 'right', 'anticlockwise')
        "
        class="sub-box"
        :class="{
          red: grid.row2.box3.isRed,
          blue: grid.row2.box3.isBlue,
          yellow: grid.row2.box3.isYellow,
          green: grid.row2.box3.isGreen,
          gray: grid.row2.box3.isGray,
          pink: grid.row2.box3.isPink,
        }"
      ></v-touch>
    </v-touch>
    <v-touch
      @swipeleft="
        direction1
          ? horizontalSweep('downLeft', 'down', 'anticlockwise')
          : horizontalSweep('downRight', 'down', 'clockwise')
      "
      @swiperight="
        direction1
          ? horizontalSweep('downRight', 'down', 'clockwise')
          : horizontalSweep('downLeft', 'down', 'anticlockwise')
      "
      class="row"
    >
      <v-touch
        @swipeup="
          direction
            ? verticalSweep('leftUp', 'left', 'clockwise')
            : verticalSweep('leftDown', 'left', 'anticlockwise')
        "
        @swipedown="
          direction
            ? verticalSweep('leftDown', 'left', 'anticlockwise')
            : verticalSweep('leftUp', 'left', 'clockwise')
        "
        class="sub-box"
        :class="{
          red: grid.row3.box1.isRed,
          blue: grid.row3.box1.isBlue,
          yellow: grid.row3.box1.isYellow,
          green: grid.row3.box1.isGreen,
          gray: grid.row3.box1.isGray,
          pink: grid.row3.box1.isPink,
        }"
      ></v-touch>
      <v-touch
        @swipeup="direction ? verticalSweep('midUp') : verticalSweep('midDown')"
        @swipedown="
          direction ? verticalSweep('midDown') : verticalSweep('midUp')
        "
        class="sub-box"
        :class="{
          red: grid.row3.box2.isRed,
          blue: grid.row3.box2.isBlue,
          yellow: grid.row3.box2.isYellow,
          green: grid.row3.box2.isGreen,
          gray: grid.row3.box2.isGray,
          pink: grid.row3.box2.isPink,
        }"
      ></v-touch>
      <v-touch
        @swipeup="
          direction
            ? verticalSweep('rightUp', 'right', 'anticlockwise')
            : verticalSweep('rightDown', 'right', 'clockwise')
        "
        @swipedown="
          direction
            ? verticalSweep('rightDown', 'right', 'clockwise')
            : verticalSweep('rightUp', 'right', 'anticlockwise')
        "
        class="sub-box"
        :class="{
          red: grid.row3.box3.isRed,
          blue: grid.row3.box3.isBlue,
          yellow: grid.row3.box3.isYellow,
          green: grid.row3.box3.isGreen,
          gray: grid.row3.box3.isGray,
          pink: grid.row3.box3.isPink,
        }"
      ></v-touch>
    </v-touch>
  </div>
</template>

<script>
import { bus } from "../main";
export default {
  name: "rubixSide",
  props: {
    up: {
      type: Array,
      required: true,
    },
    right: {
      type: Array,
      required: true,
    },
    color: {
      type: String,
      required: true,
    },
    view: {
      type: String,
      required: true,
    },
    toRotate: {
      type: Object,
      required: true,
    },
    direction: {
      type: Boolean,
      default: true,
    },
    direction1: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      grid: {
        row1: {
          box1: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
          box2: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
          box3: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
        },
        row2: {
          box1: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
          box2: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
          box3: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
        },
        row3: {
          box1: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
          box2: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
          box3: {
            isRed: false,
            isBlue: false,
            isYellow: false,
            isGreen: false,
            isGray: false,
            isPink: false,
          },
        },
      },
      rotates: {},
      // currentMidUp: [],
    };
  },
  methods: {
    change(tempColor) {
      const color = "is" + tempColor;
      //Row 1
      this.grid.row1.box1[color] = true;
      this.grid.row1.box2[color] = true;
      this.grid.row1.box3[color] = true;

      //Row 2
      this.grid.row2.box1[color] = true;
      this.grid.row2.box2[color] = true;
      this.grid.row2.box3[color] = true;

      //Row 3
      this.grid.row3.box1[color] = true;
      this.grid.row3.box2[color] = true;
      this.grid.row3.box3[color] = true;
    },
    verticalSweep(type, emitRotate = "none", direction) {
      const toPass = [...this.up];
      let index = toPass.indexOf(this.view);
      let box1 = this.grid["row1"].box2;
      let box2 = this.grid["row2"].box2;
      let box3 = this.grid["row3"].box2;
      let data = { box1, box2, box3 };
      let name;
      if (emitRotate != "none") {
        const rotatename = this.toRotate[emitRotate] + "rotate";
        bus.$emit(rotatename, direction);
      }
      switch (type) {
        case "midUp":
          if (index + 1 != toPass.length) {
            index += 1;
          } else {
            index = 0;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "midUp",
            sender: this.view,
            colors: data,
            toPass: toPass,
          });
          break;
        case "midDown":
          if (index - 1 >= 0) {
            index -= 1;
          } else {
            index = toPass.length - 1;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "midDown",
            sender: this.view,
            colors: data,
            toPass: toPass,
          });
          break;
        case "leftUp":
          box1 = this.grid["row1"].box1;
          box2 = this.grid["row2"].box1;
          box3 = this.grid["row3"].box1;
          data = { box1, box2, box3 };
          if (index + 1 != toPass.length) {
            index += 1;
          } else {
            index = 0;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "leftUp",
            sender: this.view,
            colors: data,
            toPass: toPass,
          });
          break;
        case "leftDown":
          box1 = this.grid["row1"].box1;
          box2 = this.grid["row2"].box1;
          box3 = this.grid["row3"].box1;
          data = { box1, box2, box3 };
          if (index - 1 >= 0) {
            index -= 1;
          } else {
            index = toPass.length - 1;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "leftDown",
            sender: this.view,
            colors: data,
            toPass: toPass,
          });
          break;
        case "rightUp":
          box1 = this.grid["row1"].box3;
          box2 = this.grid["row2"].box3;
          box3 = this.grid["row3"].box3;
          data = { box1, box2, box3 };
          if (index + 1 != toPass.length) {
            index += 1;
          } else {
            index = 0;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "rightUp",
            sender: this.view,
            colors: data,
            toPass: toPass,
          });
          break;
        case "rightDown":
          box1 = this.grid["row1"].box3;
          box2 = this.grid["row2"].box3;
          box3 = this.grid["row3"].box3;
          data = { box1, box2, box3 };
          if (index - 1 >= 0) {
            index -= 1;
          } else {
            index = toPass.length - 1;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "rightDown",
            sender: this.view,
            colors: data,
            toPass: toPass,
          });
          break;
        default:
          console.log("Please input a valid parameter");
      }
    },
    horizontalSweep(type, emitRotate = "none", direction) {
      const toPass = [...this.right];
      let index = toPass.indexOf(this.view);
      let name;
      if (emitRotate != "none") {
        const rotatename = this.toRotate[emitRotate] + "rotate";
        bus.$emit(rotatename, direction);
      }

      switch (type) {
        case "midRight":
          if (index + 1 != toPass.length) {
            index += 1;
          } else {
            index = 0;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "midRight",
            sender: this.view,
            colors: this.grid["row2"],
            toPass: toPass,
          });
          break;
        case "midLeft":
          if (index - 1 >= 0) {
            index -= 1;
          } else {
            index = toPass.length - 1;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "midLeft",
            sender: this.view,
            colors: this.grid["row2"],
            toPass: toPass,
          });
          break;
        case "upRight":
          if (index + 1 != toPass.length) {
            index += 1;
          } else {
            index = 0;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "upRight",
            sender: this.view,
            colors: this.grid["row1"],
            toPass: toPass,
          });
          break;
        case "upLeft":
          if (index - 1 >= 0) {
            index -= 1;
          } else {
            index = toPass.length - 1;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "upLeft",
            sender: this.view,
            colors: this.grid["row1"],
            toPass: toPass,
          });
          break;
        case "downRight":
          if (index + 1 != toPass.length) {
            index += 1;
          } else {
            index = 0;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "downRight",
            sender: this.view,
            colors: this.grid["row3"],
            toPass: toPass,
          });
          break;
        case "downLeft":
          if (index - 1 >= 0) {
            index -= 1;
          } else {
            index = toPass.length - 1;
          }
          name = toPass[index];
          bus.$emit(name, {
            type: "downLeft",
            sender: this.view,
            colors: this.grid["row3"],
            toPass: toPass,
          });
          break;

        default:
          console.log("Please input a valid parameter");
      }
    },
  },

  created() {
    this.change(this.color);
    this.rotates = this.toRotate;
    const name = this.view + "rotate";
    const showGrid = "showGrid" + this.view;
    const shuffle = this.view + "Shuffle";
    const positions = ["mid", "left", "right", "up", "down"];
    const movements = ["Up", "Down", "Left", "Right"];
    const checkEquality = (grid) => {
      let colors = ["Red", "Blue", "Yellow", "Green", "Gray", "Pink"];
      for (let color of colors) {
        const check = "is" + color;
        const row1 =
          this.grid.row1.box1[check] == true &&
          this.grid.row1.box2[check] == true &&
          this.grid.row1.box3[check] == true;
        const row2 =
          this.grid.row2.box1[check] == true &&
          this.grid.row2.box2[check] == true &&
          this.grid.row2.box3[check] == true;
        const row3 =
          this.grid.row3.box1[check] == true &&
          this.grid.row3.box2[check] == true &&
          this.grid.row3.box3[check] == true;
        const col1 =
          this.grid.row1.box1[check] == true &&
          this.grid.row2.box1[check] == true &&
          this.grid.row3.box1[check] == true;
        const view = this.view;
        if (row1 && row2 && row3 && col1) {
          return true;
        }
      }
      return false;
    };
    bus.$on(this.view, (data) => {
      let box1 = this.grid["row1"].box2;
      let box2 = this.grid["row2"].box2;
      let box3 = this.grid["row3"].box2;
      let name;
      const type = data.type;
      let firstPart = "";
      let typeMovement = "";
      if (type.includes("right") || type.includes("up")) {
        firstPart = ["right", "up"];
      } else if (type.includes("left") || type.includes("down")) {
        firstPart = ["left", "down"];
      } else {
        firstPart = ["mid", "mid"];
      }
      if (this.up.next(this.view) == data.sender) {
        typeMovement = firstPart[0] + "Down";
      } else if (this.up.previous(this.view) == data.sender) {
        typeMovement = firstPart[0] + "Up";
      } else if (this.right.next(this.view) == data.sender) {
        typeMovement = firstPart[1] + "Left";
      } else {
        typeMovement = firstPart[1] + "Right";
      }
      data.type = typeMovement;
      switch (data.type) {
        case "midUp":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index + 1 != data.toPass.length) {
              index += 1;
            } else {
              index = 0;
            }
            name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "midUp",
              sender: this.view,
              colors: { box1, box2, box3 },
              toPass: data.toPass,
            });
            this.grid["row1"].box2 = data.colors.box1;
            this.grid["row2"].box2 = data.colors.box2;
            this.grid["row3"].box2 = data.colors.box3;
          } else {
            this.grid["row1"].box2 = data.colors.box1;
            this.grid["row2"].box2 = data.colors.box2;
            this.grid["row3"].box2 = data.colors.box3;
          }
          break;
        case "midDown":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index - 1 < 0) {
              index = data.toPass.length - 1;
            } else {
              index -= 1;
            }
            let name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "midDown",
              sender: this.view,
              colors: { box1, box2, box3 },
              toPass: data.toPass,
            });
            this.grid["row1"].box2 = data.colors.box1;
            this.grid["row2"].box2 = data.colors.box2;
            this.grid["row3"].box2 = data.colors.box3;
          } else {
            this.grid["row1"].box2 = data.colors.box1;
            this.grid["row2"].box2 = data.colors.box2;
            this.grid["row3"].box2 = data.colors.box3;
          }
          break;
        case "leftUp":
          box1 = this.grid["row1"].box1;
          box2 = this.grid["row2"].box1;
          box3 = this.grid["row3"].box1;

          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index + 1 != data.toPass.length) {
              index += 1;
            } else {
              index = 0;
            }
            name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "leftUp",
              sender: this.view,
              colors: { box1, box2, box3 },
              toPass: data.toPass,
            });
            this.grid["row1"].box1 = data.colors.box1;
            this.grid["row2"].box1 = data.colors.box2;
            this.grid["row3"].box1 = data.colors.box3;
          } else {
            this.grid["row1"].box1 = data.colors.box1;
            this.grid["row2"].box1 = data.colors.box2;
            this.grid["row3"].box1 = data.colors.box3;
          }
          break;
        case "leftDown":
          box1 = this.grid["row1"].box1;
          box2 = this.grid["row2"].box1;
          box3 = this.grid["row3"].box1;
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index - 1 < 0) {
              index = data.toPass.length - 1;
            } else {
              index -= 1;
            }
            let name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "leftDown",
              sender: this.view,
              colors: { box1, box2, box3 },
              toPass: data.toPass,
            });
            this.grid["row1"].box1 = data.colors.box1;
            this.grid["row2"].box1 = data.colors.box2;
            this.grid["row3"].box1 = data.colors.box3;
          } else {
            this.grid["row1"].box1 = data.colors.box1;
            this.grid["row2"].box1 = data.colors.box2;
            this.grid["row3"].box1 = data.colors.box3;
          }
          break;
        case "rightUp":
          box1 = this.grid["row1"].box3;
          box2 = this.grid["row2"].box3;
          box3 = this.grid["row3"].box3;
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index + 1 != data.toPass.length) {
              index += 1;
            } else {
              index = 0;
            }
            name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "rightUp",
              sender: this.view,
              colors: { box1, box2, box3 },
              toPass: data.toPass,
            });
            this.grid["row1"].box3 = data.colors.box1;
            this.grid["row2"].box3 = data.colors.box2;
            this.grid["row3"].box3 = data.colors.box3;
          } else {
            this.grid["row1"].box3 = data.colors.box1;
            this.grid["row2"].box3 = data.colors.box2;
            this.grid["row3"].box3 = data.colors.box3;
          }

          break;
        case "rightDown":
          box1 = this.grid["row1"].box3;
          box2 = this.grid["row2"].box3;
          box3 = this.grid["row3"].box3;
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index - 1 < 0) {
              index = data.toPass.length - 1;
            } else {
              index -= 1;
            }
            let name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "rightDown",
              sender: this.view,
              colors: { box1, box2, box3 },
              toPass: data.toPass,
            });
            this.grid["row1"].box3 = data.colors.box1;
            this.grid["row2"].box3 = data.colors.box2;
            this.grid["row3"].box3 = data.colors.box3;
          } else {
            this.grid["row1"].box3 = data.colors.box1;
            this.grid["row2"].box3 = data.colors.box2;
            this.grid["row3"].box3 = data.colors.box3;
          }
          break;

        case "midRight":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index + 1 != data.toPass.length) {
              index += 1;
            } else {
              index = 0;
            }
            name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "midRight",
              sender: this.view,
              colors: this.grid["row2"],
              toPass: data.toPass,
            });
            this.grid["row2"] = data.colors;
          } else {
            this.grid["row2"] = data.colors;
          }
          break;
        case "midLeft":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index - 1 < 0) {
              index = data.toPass.length - 1;
            } else {
              index -= 1;
            }
            let name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "midLeft",
              sender: this.view,
              colors: this.grid["row2"],
              toPass: data.toPass,
            });
            this.grid["row2"] = data.colors;
          } else {
            this.grid["row2"] = data.colors;
          }
          break;
        case "upRight":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index + 1 != data.toPass.length) {
              index += 1;
            } else {
              index = 0;
            }
            name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "upRight",
              sender: this.view,
              colors: this.grid["row1"],
              toPass: data.toPass,
            });
            this.grid["row1"] = data.colors;
          } else {
            this.grid["row1"] = data.colors;
          }
          break;
        case "upLeft":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index - 1 < 0) {
              index = data.toPass.length - 1;
            } else {
              index -= 1;
            }
            let name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "upLeft",
              sender: this.view,
              colors: this.grid["row1"],
              toPass: data.toPass,
            });
            this.grid["row1"] = data.colors;
          } else {
            this.grid["row1"] = data.colors;
          }
          break;
        case "downRight":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index + 1 != data.toPass.length) {
              index += 1;
            } else {
              index = 0;
            }
            name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "downRight",
              sender: this.view,
              colors: this.grid["row3"],
              toPass: data.toPass,
            });
            this.grid["row3"] = data.colors;
          } else {
            this.grid["row3"] = data.colors;
          }
          break;
        case "downLeft":
          if (data.toPass.length > 1) {
            let index = data.toPass.indexOf(this.view);
            if (index - 1 < 0) {
              index = data.toPass.length - 1;
            } else {
              index -= 1;
            }
            let name = data.toPass[index];
            data.toPass.splice(data.toPass.indexOf(this.view), 1);
            bus.$emit(name, {
              type: "downLeft",
              sender: this.view,
              colors: this.grid["row3"],
              toPass: data.toPass,
            });
            this.grid["row3"] = data.colors;
          } else {
            this.grid["row3"] = data.colors;
          }
          break;
        default:
          console.log("Please input a valid parameter");
      }
      bus.$emit("Completed changing values");
    });
    bus.$on(shuffle, () => {
      movements.sort(() => Math.random() - Math.random());
      positions.sort(() => Math.random() - Math.random());
      const movement = movements[0];
      const position = positions[0];

      const action = position + movement;
      console.log(action);
      if (movement === "Up" || movement === "Down") {
        this.verticalSweep(action);
      } else {
        this.horizontalSweep(action);
      }
    });
    bus.$on(name, (data) => {
      const grid = this.grid;
      const row1 = { ...grid["row1"] };
      const row2 = { ...grid["row2"] };
      const row3 = { ...grid["row3"] };
      if (data == "clockwise") {
        this.grid["row1"].box1 = row1.box1;
        this.grid["row2"].box1 = row1.box2;
        this.grid["row3"].box1 = row1.box3;

        this.grid["row1"].box2 = row2.box3;
        this.grid["row2"].box2 = row2.box2;
        this.grid["row3"].box2 = row2.box1;

        this.grid["row1"].box3 = row3.box3;
        this.grid["row2"].box3 = row3.box2;
        this.grid["row3"].box3 = row3.box1;
      } else {
        this.grid["row1"].box1 = row3.box1;
        this.grid["row2"].box1 = row3.box2;
        this.grid["row3"].box1 = row3.box3;

        this.grid["row1"].box3 = row1.box1;
        this.grid["row2"].box3 = row1.box2;
        this.grid["row3"].box3 = row1.box3;

        this.grid["row1"].box2 = row2.box1;
        this.grid["row2"].box2 = row2.box2;
        this.grid["row3"].box2 = row2.box3;
      }
    });
    bus.$on(showGrid, () => {
      const result = checkEquality(this.grid);
      bus.$emit("grid", result);
    });
  },
};
</script>

<style scoped>
.view {
  height: 20px;
  background-color: white;
  max-width: 133px;
  text-align: center;
}
.side {
  height: 153px;
  max-width: 133px;
  background: black;
  overflow: hidden;
}
.row {
  display: flex;
  flex-wrap: wrap;
  /* flex-basis: 140px; */
}
.sub-box {
  width: 40px;
  height: 40px;
  margin: 2px;
}
.red {
  background-color: red;
}
.blue {
  background-color: blue;
}
.yellow {
  background-color: yellow;
}
.green {
  background-color: rgb(170, 215, 81);
}
.gray {
  background-color: gray;
}
.pink {
  background-color: pink;
}
</style>
